import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpandArrowsAlt } from "@fortawesome/pro-regular-svg-icons/faExpandArrowsAlt";
import { faCompressArrowsAlt } from "@fortawesome/pro-regular-svg-icons/faCompressArrowsAlt";
import MuiIconButton, { MuiIconButtonProps } from "components/MuiExtras/MuiIconButton";
import { useTranslation } from 'react-i18next';

interface IProps {
    expanded: boolean;
}

type Props = IProps & MuiIconButtonProps;

const IconButtonExpandScreen: React.FC<Props> = (props) => {
    const { expanded, title, ...rest } = props;
    const { t } = useTranslation();
    const finalTitle = title != null ? title
        : expanded
            ? t("Common.Buttons.RestoreScreenTitle")
            : t("Common.Buttons.FullScreenTitle");

    return (
        <MuiIconButton
            title={finalTitle}
            {...rest}
        >
            <FontAwesomeIcon fixedWidth icon={expanded ? faCompressArrowsAlt : faExpandArrowsAlt} />
        </MuiIconButton>
    );
};

export default IconButtonExpandScreen;
